import { useSearchParams } from 'react-router-dom';

export type TriageView = 'priority' | 'inbox' | 'customer';

export function useTriageView() {
  const [searchParams, setSearchParams] = useSearchParams();

  const viewParam = searchParams.get('view');
  const view: TriageView =
    viewParam === 'inbox' || viewParam === 'customer' ? viewParam : 'priority';
  const selectedCustomerId = searchParams.get('customer');

  const setView = (next: TriageView) => {
    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('view', next);
    if (next !== 'customer') nextParams.delete('customer');
    setSearchParams(nextParams, { replace: true });
  };

  const setSelectedCustomerId = (customerId: string | null) => {
    const nextParams = new URLSearchParams(searchParams);
    if (customerId) nextParams.set('customer', customerId);
    else nextParams.delete('customer');
    setSearchParams(nextParams, { replace: true });
  };

  return { view, setView, selectedCustomerId, setSelectedCustomerId };
}
